import React from "react";
import ContactSection1 from "./ContactSection1";
import ContactSection2 from "./ContactSection2";
import { ContactSection3 } from "./ContactSection3";
import ContactSection4 from "./ContactSection4";
import Layout from "../../components/Layout";

const Contact = () => {
  return (
    <Layout
      title={"MBA Solutions - Contact Us "}
      keywords={
        "Contact, Contact Us, Get in Touch, Reach Us, MBA Solutions ,MBA Solutions Contact, Contact Information, Contact Form"
      }
    >
      <div className="">
        <ContactSection1 />
        <div className="bg-[#F2F2F2] py-12 md:py-16 bg-gradient-to-b from-[#F8F8F8] via-[#F2F2F2] to-[#ECECEC]">
          <div className="mx-auto w-[92%] md:w-[88%] lg:w-[84%] mb-8 md:mb-12">
            <h1 className="text-[#1B1C19] text-center font-bold text-3xl md:text-4xl">
              Contact Us
            </h1>
            <p className="text-center text-[#4c4d56] mt-3 text-sm md:text-base max-w-3xl mx-auto">
              We are here to help you with certifications, compliance, and
              business growth support. Reach out through your preferred channel.
            </p>
          </div>
          <ContactSection2 />
          <ContactSection3 />
          {/* <ContactSection4 /> */}
        </div>
      </div>
    </Layout>
  );
};

export default Contact;
